import * as React from 'react';

export const popperOpenContext = React.createContext<
  [boolean, React.Dispatch<React.SetStateAction<boolean>>]
>([false, () => { throw new Error('popper open context provider missing'); }]);
